__turbopack_context__.v({
  "brandMenuContainer": "Nav-module__ajVNva__brandMenuContainer",
  "brandMenuLink": "Nav-module__ajVNva__brandMenuLink",
  "brandMenuList": "Nav-module__ajVNva__brandMenuList",
  "chevron": "Nav-module__ajVNva__chevron",
  "inner": "Nav-module__ajVNva__inner",
  "megaMenuLeft": "Nav-module__ajVNva__megaMenuLeft",
  "megaMenuWrap": "Nav-module__ajVNva__megaMenuWrap",
  "menuContainer": "Nav-module__ajVNva__menuContainer",
  "menuItem": "Nav-module__ajVNva__menuItem",
  "menuList": "Nav-module__ajVNva__menuList",
  "submenuLink": "Nav-module__ajVNva__submenuLink",
  "submenuList": "Nav-module__ajVNva__submenuList",
  "submenuPanel": "Nav-module__ajVNva__submenuPanel",
});
